export default __webpack_public_path__ + "static/media/o.4b60676d.mp4";